/* eslint-disable no-use-before-define */
import React from 'react';
import TextField from '@mui/material/TextField';
import { Autocomplete, Avatar } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from "react-i18next";
import { MAIN_COLOR } from "../common/sharedFunctions";

const useStyles = makeStyles({
  option1: {
    fontSize: 15,
    padding: '8px 16px !important',
  },
  option2: {
    fontSize: 15,
    padding: '8px 16px !important',
    direction: 'rtl'
  },
  inputRtl: {
    "& label": {
      right: 75,
      left: "auto"
    },
    "& legend": {
      textAlign: "right",
      marginRight: 65
    }
  },
  textField: {
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
  },
});

export default function UsersCombo(props) {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir();
  const classes = useStyles();
  return (
    <Autocomplete
      value={props.value}
      id="user-select"
      style={props.style}
      options={props.users}
      classes={isRTL === 'rtl' ? { option: classes.option2 } : { option: classes.option1 }}
      onChange={props.onChange}
      autoHighlight
      getOptionLabel={(option) => {
        if (!option) return '';
        if (option.firstName) return `${option.firstName} ${option.lastName} (${option.mobile})`;
        return option.desc || '';
      }}
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) return false;
        return option.uid === value.uid || option.desc === value.desc;
      }}
      renderOption={(props, option) => {
        const initials = `${option.firstName ? option.firstName.charAt(0) : ''}${option.lastName ? option.lastName.charAt(0) : ''}`.toUpperCase() || 'U';
        return (
          <li {...props} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 16px' }}>
            <Avatar style={{
              width: 32,
              height: 32,
              fontSize: 12,
              fontWeight: 700,
              backgroundColor: 'rgba(72, 127, 255, 0.1)',
              color: 'var(--primary)',
              fontFamily: 'Outfit, sans-serif'
            }}>
              {initials}
            </Avatar>
            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0, textAlign: isRTL === 'rtl' ? 'right' : 'left' }}>
              <span style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-main)', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {option.firstName} {option.lastName}
              </span>
              <span style={{ fontSize: '11px', color: 'var(--text-secondary)', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginTop: '2px' }}>
                {option.mobile} • {option.email}
              </span>
            </div>
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={props.placeholder}
          variant="outlined"
          className={[isRTL === 'rtl' ? classes.inputRtl : classes.commonInputStyle, classes.textField].join(" ")}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'off'
          }}
        />
      )}
    />
  );
}